<nav
  class="fixed pb-7 z-10 bottom-0 left-0 right-0 bg-white bg-opacity-90 backdrop-blur-md py-2 shadow-[0_-2px_4px_0px_rgba(0,0,0,0.1)]"
>
  <ul class="flex justify-center items-center gap-5 h-full w-full">
    @for (item of navigationItems; track item.routerLink) {
      @if (userRole() && item.permissions.includes(userRole()!)) {
        <li class="w-16">
          <a
            class="flex flex-col justify-center items-center"
            [routerLink]="'/' + item.routerLink"
          >
            <app-icon
              [path]="item.iconPath"
              [height]="30"
              [width]="30"
              [color]="isSelected(item.routerLink) ? 'var(--blue)' : 'var(--mid-grey)'"
            />

            <span
              class="text-md font-medium"
              [ngClass]="{
                'text-blue': isSelected(item.routerLink),
                'text-mid-grey': !isSelected(item.routerLink),
              }"
            >
              {{ item.label }}
            </span>
          </a>
        </li>
      }
    }
  </ul>
</nav>
